import { Injectable } from '@angular/core';
import { CommonService } from "../common.service";
import { UserPreference } from '../../models';
import * as moment from 'moment';
import { WidgethelperService } from "../widgethelper.service";
import { AnalyticsService } from "../analytics.service";
import { BaseService } from "./base.service";
import {  errorMessages, appSettings } from "../../settings";
import { WidgetDetailParam } from '../../models/WidgetDetailParam';

@Injectable()
export class OrdersummaryService extends BaseService {

  constructor(private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService,) {
      super();
 }  

 init(widget: any) {   
  widget.dataLoaded = false;
  widget.Title = 'Customer Order Summary';

  let userPref: UserPreference = this._commonService.getUserPreference();

  let param = new WidgetDetailParam();
  param.CustomerId = userPref.CustomerId;
  param.FacilityId = userPref.FacilityId;
  param.StartDate = new Date(moment().add(-30, "days").format("l"));
  param.EndDate = new Date();

  this._analyticsService.getOrderSummary(param)
    .subscribe((result: any) => {       
      widget.errorMessage = null;
      if (result && result.length > 0) {
        widget.dataLoaded = false;
        let ordersDropped = []; 
        let unitsDropped = []; 
        let unitsPicked = []; 
        let unitsPacked = []; 
        let shippedOrdersOntg = []; 
        let shippedUnitsOntg = []; 
        let shippedOrdersFdx = []; 
        let shippedUnitsFdx = []; 
        let shippedOrdersNewg = []; 
        let shippedUnitsNewg = []; 
        let totalShippedOrders = []; 
        let totalShippedUnits = []; 
        let xAxisData = []; 
        result.forEach(el => {
            let rptdate = null;
            rptdate = el.REPORT_DATE ?
                      this._commonService.formatDate(new Date(el.REPORT_DATE),appSettings.chartDayFormat)
                      : null;
            if (rptdate && xAxisData.indexOf(rptdate) == -1) {
              ordersDropped.push(el.ORDERS_DROPPED);
              unitsDropped.push(el.UNITS_DROPPED);
              unitsPicked.push(el.UNITS_PICKED);
              unitsPacked.push(el.UNITS_PACKED);
              shippedOrdersOntg.push(el.SHIPPED_ORDERS_ONTG);
              shippedUnitsOntg.push(el.SHIPPED_UNITS_ONTG);
              shippedOrdersFdx.push(el.SHIPPED_ORDERS_FEDEX);
              shippedUnitsFdx.push(el.SHIPPED_UNITS_FEDEX);
              shippedOrdersNewg.push(el.SHIPPED_ORDERS_NEWG);
              shippedUnitsNewg.push(el.SHIPPED_UNITS_NEWG);
              totalShippedOrders.push(el.TOTAL_SHIPPED_ORDERS);
              totalShippedUnits.push(el.TOTAL_SHIPPED_UNITS);

              xAxisData.push(rptdate)
            }
        });  
        
        widget.chartOptions = this.chartOptions();
        this.addDataSeries(widget.chartOptions,ordersDropped,'Orders Dropped','bar','1')     
        this.addDataSeries(widget.chartOptions,unitsDropped,'Units Dropped','bar','1')  
        this.addDataSeries(widget.chartOptions,unitsPicked,'Units Picked','bar','1')  
        this.addDataSeries(widget.chartOptions,unitsPacked,'Units Packed','bar','1')     
        this.addDataSeries(widget.chartOptions,shippedOrdersOntg,'Shipped Orders Ontg','bar','1')  
        this.addDataSeries(widget.chartOptions,shippedUnitsOntg,'Shipped Units Ontg','bar','1')
        this.addDataSeries(widget.chartOptions,shippedOrdersFdx,'Shipped Orders Fedex','bar','1')     
        this.addDataSeries(widget.chartOptions,shippedUnitsFdx,'Shipped Units Fedex','bar','1')  
        this.addDataSeries(widget.chartOptions,shippedOrdersNewg,'Shipped Orders Newgistics','bar','1')  
        this.addDataSeries(widget.chartOptions,shippedUnitsNewg,'Shipped Units Newgistics','bar','1')     
        this.addDataSeries(widget.chartOptions,totalShippedOrders,'Total Shipped Orders','bar','1')  
        this.addDataSeries(widget.chartOptions,totalShippedUnits,'Total Shipped Units','bar','1')
        this.addZoomBar(widget.chartOptions);
        widget.chartOptions.xAxis.data = xAxisData;
        widget.chartOptions.xAxis.axisLabel.rotate = 45;         
      }
      else {
        widget.errorMessage = errorMessages.noWidgetData;
      }
      widget.dataLoaded = true;

     },
     err => {
      console.log('getOrderSummary', err);
      widget.errorMessage = errorMessages.apiError;
      widget.dataLoaded = true;
    }
  );
}

reload(widget: any) { }

remove(widget: any) { }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/Ordersummary.service.ts